<template>
  <div>
    <div class="d-flex numeriArea flex-wrap " :class="$vuetify.breakpoint.mdAndDown && 'pr-3' ">
      <div  v-for="(item , i ) in items" :key="i" class="mx-1 mt-4" style="cursor: pointer" >
        <div class="selectableItem  d-flex flex-column justify-space-around " :class="radioSelected == item.id && 'activeOption'" @click="setRadioSelected(item.id)">
          <template v-if="$vuetify.rtl">
            {{ item.text }}
          </template>
          <template v-else>
            {{ item.en_text }}
          </template>
        </div>
      </div>
    </div>
    <v-btn class="confirmBtn" block color="#3CBE8B" elevation="0" @click="changes" v-if="$vuetify.breakpoint.lgAndUp">
      {{$t('matchMaking.buttons.submit') }}
    </v-btn>
  </div>
</template>

<script>

export default {
  props: {
    items: Array,
    language: {
      default: 'fa'
    },
    callChangeInOption: Boolean,
  },
  data() {
    return {
      radioSelected: null,
    }
  },
  methods: {
    setRadioSelected(id) {
      this.radioSelected = id
    },
    changes() {
      if (this.radioSelected) {
        this.$emit('answerHandler', [
          {
            'question_option_id': this.radioSelected,
          },
        ])
      } else {
        this.$emitEvent('notify', {color: 'red', title: this.$t('matchMaking.pleaseAnswer')});
      }
    }
  },
  watch: {
    callChangeInOption(val) {
      if (val) {
        this.changes()
      }
    }
  }
}

</script>

<style scoped>
@media (min-width: 200px ) and (max-width:600px ) {
  .numeriArea{
    width: 100% !important;
    margin: 0px auto !important ;
  }
  .selectableItem{
    width: 50px !important;
    height: 50px !important;
  }
}
.selectableItem{
  width: 55px;
  height: 55px;
  font-size: 10pt;
  border-radius: 10px;
  display: flex;
  text-align: center;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  border: 1px solid #E1E1E1;
  background: #FFF;
  transition: all 0.3s;
  cursor: pointer;
  margin-bottom: 13px;
}
.selectableItem:hover{
  transition: all 0.3s;
  border-color: #39C990 !important;
  background: linear-gradient(180deg, #FFF 0%, rgba(215, 244, 233, 0.80) 100%) !important;
}
.imageArea img{
  width: 120px;
}
.activeArea{
  position: absolute;
  top: 3px;
  right: 3px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #4576d8;
}
.activeItem{
  border: 3px solid #4576d8;
}
.numeriArea{
  padding-right: 20px;
  margin: auto;
}

.activeOption {
  border: 1px solid #39C990;
  background: linear-gradient(180deg, #FFF 0%, rgba(215, 244, 233, 0.80) 100%) !important;
}
</style>
